import axios from "axios";

export function navInit() {
    document.addEventListener('DOMContentLoaded', function () {
        const hamburger = document.querySelector('.header__hamburger');
        const mobileMenu = document.querySelector('.mobileMenu');
        const elements = document.querySelectorAll('.mobileMenu .header__category li.menu-item-has-children');
        const arrowRight = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4244 7.07573C15.6587 7.31004 15.6587 7.68994 15.4244 7.92426L10.4244 12.9243C10.19 13.1586 9.81015 13.1586 9.57583 12.9243L4.57583 7.92426C4.34152 7.68994 4.34152 7.31004 4.57583 7.07573C4.81015 6.84141 5.19005 6.84141 5.42436 7.07573L10.0001 11.6515L14.5758 7.07573C14.8101 6.84142 15.19 6.84142 15.4244 7.07573Z" fill="white"/>
      </svg>`;

        if (hamburger && mobileMenu) {
            hamburger.addEventListener('click', function () {
                hamburger.classList.toggle('active');
                mobileMenu.classList.toggle('active');
            })
        }

        window.addEventListener('scroll', function () {
            const header = document.querySelector('.header');

            if (window.scrollY > 100 && window.innerWidth > 992) {
                header.classList.add('shrink');
            } else {
                header.classList.remove('shrink');
            }
        });


        elements.forEach(element => {
            const item = element.querySelector('a');
            const spanArrow = document.createElement('span');
            spanArrow.setAttribute('class', 'arrow-right');
            spanArrow.innerHTML = arrowRight;
            item.appendChild(spanArrow);

            item.addEventListener("click", (e) => {
                e.preventDefault();
                if (item.classList.contains('open')) {
                    item.classList.remove('open');
                    element.querySelector('.sub-menu').classList.remove('open');
                } else {
                    item.classList.add('open');
                    element.querySelector('.sub-menu').classList.add('open');
                }
            })
        })

        jQuery(function ($) {
            $(document).on('added_to_wishlist removed_from_wishlist', function () {
                $.get(yith_wcwl_l10n.ajax_url, {
                    action: 'yith_wcwl_update_wishlist_count'
                }, function (data) {
                    jQuery('.link-item__badge--wishlist').html(data.count);
                });
            });
        });

    });
}

export const initHeaderBar = () => {
    if(window.innerWidth > 992) return;
    const headerBar = document.querySelector('.header__bar');
    if(!headerBar) return;
    const headerBarInners = headerBar.querySelector('.header__bar__inner');
    const content = Array.from(headerBarInners.children);

    content.forEach(item => {
        const dupItem = item.cloneNode(true);
        dupItem.setAttribute('aria-hidden', true);
        headerBarInners.appendChild(dupItem);
    });
}

export const initMegaMenu = () => {
    const mainMenuItems = document.querySelectorAll('.menu__main--has-children');
    const submenuCategories = document.querySelectorAll('.submenu-category');
    const subItems = document.querySelectorAll('.sub-item');
    const subEls = document.querySelectorAll('.sub-el');
    let activeSubItem = null;
    let hoverTimer = null;

    if(mainMenuItems && submenuCategories) {
        mainMenuItems.forEach(mainMenuItem => {
            const submenuCategory = mainMenuItem.querySelector('.submenu-category');
            const submenuItem = submenuCategory.querySelector('.sub-item');
            const submenuItemId = submenuItem.getAttribute('data-id');

            mainMenuItem.addEventListener('mouseenter', () => {
                subItems.forEach(subItem => {
                    subItem.classList.remove('active');
                });

                submenuItem.classList.add('active');

                subEls.forEach(subEl => {
                    if (subEl.getAttribute('data-id') === submenuItemId) {
                        subEl.classList.add('active');
                    } else {
                        subEl.classList.remove('active');
                    }
                });

                hoverTimer = setTimeout(function() {
                    submenuCategory.classList.add('submenu-category--active');
                }, 10);
            });

            mainMenuItem.addEventListener('mouseleave', () => {
                clearTimeout(hoverTimer);
                submenuCategories.forEach(submenuItem => {
                    submenuItem.classList.remove('submenu-category--active');
                });
            });
        });
    }

    if (subItems && subEls) {
        subItems.forEach(subItem => {
            subItem.addEventListener('mouseover', () => {
                const dataId = subItem.getAttribute('data-id');

                if (activeSubItem) {
                    activeSubItem.classList.remove('active');
                }

                subItem.classList.add('active');
                activeSubItem = subItem;

                subEls.forEach(subEl => {
                    if (subEl.getAttribute('data-id') === dataId) {
                        subEl.classList.add('active');
                    } else {
                        subEl.classList.remove('active');
                    }
                });
            });
        });
    }
}

export const initSearchModal = () => {
    const searchBars = document.querySelectorAll('.productSearchBar__field');
    const searchModal = document.querySelector('.searchModal');
    const searchDiv = document.querySelector('.searchDiv');
    const headerSearchBackdrop = document.querySelector('.header__search__backdrop');
    const htmlTag = document.querySelector('html');
    const bodyTag = document.querySelector('body');

    if (searchBars && searchModal) {
        searchBars.forEach(searchBar => {
            searchBar.addEventListener('click', e => {
                e.preventDefault();
                searchDiv.classList.add('full');
                headerSearchBackdrop.classList.add('show');
            });
        })

        headerSearchBackdrop.addEventListener('click', function () {
            headerSearchBackdrop.classList.remove('show');
            searchModal.classList.remove('active');
            htmlTag.classList.remove('overflow-hidden');
            bodyTag.classList.remove('overflow-hidden');
        })

        const closeModal = searchModal.querySelector('.close');
        closeModal.addEventListener('click', e => {
            e.preventDefault();
            searchModal.classList.remove('active');
            searchDiv.classList.remove('full');
            headerSearchBackdrop.classList.remove('show');
            htmlTag.classList.remove('overflow-hidden');
            bodyTag.classList.remove('overflow-hidden');
        });

        const modalForm = searchDiv.querySelector('form');
        const searchInput = searchDiv.querySelector('input');
        const searchResults = searchModal.querySelector('.searchModal__results');
        const searchLoading = searchModal.querySelector('.searchModal__loading');
        modalForm.addEventListener('submit', e => {
            e.preventDefault();
            if (searchInput.value.length > 0) window.location = `${window.location.origin}/?s=${searchInput.value}&post_type=product`;
        });

        let timeoutId;
        searchInput.addEventListener('input', () => {
            searchLoading.classList.remove('active');
            searchModal.classList.remove('large');
            clearTimeout(timeoutId);
            if (searchInput.value.length > 2) {
                timeoutId = setTimeout(() => {
                    searchResults.innerHTML = "";
                    searchLoading.classList.add('active');
                    searchModal.classList.add('active');
                    htmlTag.classList.add('overflow-hidden');
                    bodyTag.classList.add('overflow-hidden');
                    axios.post(`/wp-json/opmax/v1/search`, {
                        search: searchInput.value
                    }).then(response => {
                        searchResults.innerHTML = response.data.html;
                        searchLoading.classList.remove('active');
                        searchModal.classList.add('large');

                        const resultSlider = new window.splide('.searchModal__slider', {
                            type: 'loop',
                            gap: 24,
                            pagination: false,
                            perPage: 5,
                            arrows: false,
                            drag: true,
                            breakpoints: {
                                991: {
                                    autoWidth: false,
                                    perPage: 3,
                                },
                                767: {
                                    perPage: 2,
                                },
                                576: {
                                    gap: 16,
                                    // perPage: 1,
                                },
                            }
                        });

                        resultSlider.on('overflow', function (isOverflow) {
                            resultSlider.go(0);

                            resultSlider.options = {
                                drag: isOverflow,
                                clones: isOverflow ? undefined : 0,
                            };
                        });

                        resultSlider.mount();
                    });
                }, 500);
            } else {
                searchResults.innerHTML = "";
                searchModal.classList.remove('active');
                htmlTag.classList.remove('overflow-hidden');
                bodyTag.classList.remove('overflow-hidden');
            }
        });
    }
}